import Vue from 'vue';
import UserbackPlugin from '@userback/vue2';

Vue.use(UserbackPlugin, {token: process.env.VUE_APP_USERBACK_TOKEN})